import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=6e72ddcc&scoped=true&"
import script from "./PanelGroup.vue?vue&type=script&lang=ts&"
export * from "./PanelGroup.vue?vue&type=script&lang=ts&"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=6e72ddcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e72ddcc",
  null
  
)

export default component.exports